export const TONE_COLORS = {
  primary: "#5B4FE0",
  info: "#3AA0E8",
  success: "#12A57A",
  warning: "#D98A0B",
  danger: "#D64545",
  neutral: "#9CA3AF",
};

export const CHART_SERIES = ["#5B4FE0", "#3AA0E8", "#2BB5A6", "#F2A33A", "#E0679B", "#8B7FF0", "#6C7A96"];

export const axisProps = {
  tick: { fontSize: 12, fill: "#6B7280" },
  axisLine: { stroke: "#E5E7F0" },
  tickLine: false,
};

export const tooltipProps = {
  cursor: { fill: "rgba(91, 79, 224, 0.06)" },
  contentStyle: { borderRadius: 8, border: "1px solid #E5E7F0", fontSize: 13, boxShadow: "0 8px 24px rgba(31,36,48,.08)" },
};
